<template>
  <section class="contacts">
    <div class="contacts-info">Наши контакты</div>
    <div class="contacts-title">Агрегатор юридических документов - автоматизированная система решения любых юридических вопросов<br/>
      Автономная некоммерческая организация “ПАУ”<br/>
      Москва, Автозаводская, 23 а к 2, 115280<br/>
      телефон <span>8 800 201 0339</span><br/>
      e-mail <span>a@moi-uristy.ru</span></div>
    <div class="contacts-image"><img src="static/img/contacts/contacts.jpg" alt=""></div>
  </section>
</template>

<script>
export default {
name: 'contacts'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contacts.vue